import { useDashboardDatePreferencesTransport } from "../routes/useDashboardDatePreferencesTransport"

export const useDashboardDatePreferences = (dashboardId: string | undefined) =>
  useDashboardDatePreferencesTransport(dashboardId)
